// General
import React from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Styles
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.css';
import FontAwesome from 'react-icons/fa';
import cx from 'classnames';
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import styled from 'styled-components';

// Internal Components
import Link from '../Link';
import Navigation from '../Navigation';
import LanguageSwitcher from '../LanguageSwitcher';
import Logo from '../Logo';

// Assets
import logoUrl from './logo-small.png';
import logoUrl2x from './logo-small@2x.png';
import { geolocated } from 'react-geolocated';

// External Components
import Toaster from '../Toaster';
import { colors } from '../../tailwind';

// Redux action
import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';
import Button from '../../components_new/common/FormComponents/Button';
import { Text } from '../../components_new/common';

class Header extends React.Component {
  static propTypes = {
    borderLess: PropTypes.bool,
    showMenu: PropTypes.bool,
    toggleOpen: PropTypes.func.isRequired,
    formatMessage: PropTypes.func,
  };

  static defaultProps = {
    borderLess: false,
    showMenu: false,
  };

  constructor(props) {
    super(props);
    this.handleMenu = this.handleMenu.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
  }

  state = {
    kw: '',
    loc: '',
    lat: 0,
    lng: 0,
  };

  componentDidUpdate() {
    var abc = 123;
    if (
      !this.state.lat &&
      this.props.coords &&
      this.props.coords.latitude &&
      this.state.lat !== this.props.coords.latitude
    ) {
      this.setState({
        lat: this.props.coords.latitude,
        lng: this.props.coords.longitude,
      });
    }
  }

  handleMenu() {
    const { showMenu, toggleOpen, toggleClose } = this.props;
    if (showMenu) {
      toggleClose();
    } else {
      toggleOpen();
    }
  }

  updateKeywords = e => {
    this.setState({
      kw: e.target.value,
    });
  };

  handleKeyDown = e => {
    const { submit } = this.props;
    if (e.keyCode === 13) {
      this.submitSearch();
    }
  };

  submitSearch = () => {
    const { kw, lat, lng } = this.state;
    if (typeof window !== 'undefined') {
      let locationStr = ``;
      if (lat && lng) {
        locationStr += `lat=${lat}&lng=${lng}`;
      }
      window.location.assign(`/s?${locationStr}&keyword=${kw}`);
    }
  };

  render() {
    const {
      backgroundLess,
      showMenu,
      sticky,
      searchParams,
      hideSearch,
    } = this.props;
    let backgroundStyles = {
      backgroundColor: backgroundLess ? 'transparent' : 'white',
    };
    if (sticky) {
      backgroundStyles = Object.assign(backgroundStyles, {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 21,
      });
    }

    const inputStyle = {
      backgroundColor: 'transparent',
      border: '1px solid ' + colors.primary,
      borderRadius: '25px 0px 0px 25px',
      boxShadow: 'none',
      color: colors.grayDark,
      fontSize: '16px',
      fontFamily: 'Metropolis',
      margin: '0 auto',
      verticalAlign: 'text-bottom',
      width: '200px',
      marginBottom: '8px',
      display: 'inline-block',
    };

    return (
      <div className={s.root} style={backgroundStyles}>
        <Toaster />
        <div className={s.container}>
          <Navbar
            fluid
            className={cx(s.rentAllHeader, 'rentAllHeader')}
            expanded={showMenu}
            onToggle={this.handleMenu}
          >
            <Navbar.Header>
              <Navbar.Brand justified>
                <Logo link={'/'} className={cx(s.brand, s.brandImg)} />
              </Navbar.Brand>
              <Navbar.Toggle
                className={s.navBarToggle}
                style={{
                  float: 'right',
                }}
                children={
                  <span>
                    <Text inline primary bannersmall bold>
                      <i className="fal fa-ellipsis-v" />
                    </Text>
                  </span>
                }
              />
            </Navbar.Header>
            <Navbar.Collapse style={{ height: '55px' }}>
              {!hideSearch && (
                <Navbar.Form pullLeft style={{ height: '55px' }}>
                  <FormGroup style={{ height: '55px' }}>
                    <FormControl
                      type="text"
                      placeholder="Search for an item"
                      style={inputStyle}
                      onKeyDown={this.handleKeyDown}
                      onChange={this.updateKeywords}
                    />
                    <Button
                      secondary
                      roundedRight
                      height="34px"
                      small
                      onClick={this.submitSearch}
                      style={{
                        verticalAlign: 'text-bottom',
                        fontSize: '16px',
                        paddingRight: '16px',
                        marginBottom: '8px',
                      }}
                    >
                      <i className="fal fa-search" />
                    </Button>
                    {false &&
                      searchParams &&
                      !searchParams.loc &&
                      searchParams.lat && (
                        <Text large primary ml={3} inline>
                          <i className="fal fa-map-marker-check" />
                        </Text>
                      )}
                  </FormGroup>
                </Navbar.Form>
              )}

              <Navigation />
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  showMenu: state.toggle.showMenu,
});

const mapDispatch = {
  toggleOpen,
  toggleClose,
};

export default injectIntl(
  geolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 10000,
  })(
    withStyles(s)(
      connect(
        mapState,
        mapDispatch,
      )(Header),
    ),
  ),
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js